import React, { Component } from 'react';

import { withRouter } from 'react-router';


import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import { pedidosnfeListAction } from '../../actions/PedidosActions'


class Nfe extends Component {

    componentDidMount() {

        this.props.pedidosnfeListAction(this.props.origem, this.props.codigo)



    }



    render() {


        let { xmlnfe } = this.props;



        return (

            <div>{xmlnfe}</div>

        )
    }

}

Nfe.defaultProps = {
    origem: ''
    , codigo: ''
}
Nfe.propTypes = {
    origem: PropTypes.string.isRequired
    , codigo: PropTypes.string.isRequired

}

const mapStateToProps = state => ({
    xmlnfe: state.PedidosReducer.xmlnfe
})

export default withRouter(
    connect(mapStateToProps, {
        pedidosnfeListAction
    })
        (Nfe));